import React from 'react'
import { useTranslation } from 'react-i18next'
import { MyDrawer } from 'components/MyDrawer'

export interface MNTContentDrawerProps {
  onClose: () => void
}

export const MNTContentDrawer: React.FC<MNTContentDrawerProps> = ({ onClose }) => {
  const { t } = useTranslation('mcfStep1Page')

  return (
    <MyDrawer
      containerId='medicare-my-mnt-drawer'
      onClose={onClose}
      heading={t('MNT.where')}
      eventNamespace="mcf"
      openEventKey="mcf_mntdrawer_opendrawer"
      closeEventKey="mcf_mntdrawer_closedrawer"
    >
      <p>{t('MNT.text')}</p>
      <p>
        <span>{t('MNT.ssn')}</span>
        <a href='https://www.ssa.gov/myaccount/'>
          <span>{t('MNT.ssn2')}</span>
        </a>
      </p>
      <p>{t('MNT.phone')}</p>
      <div className='my-u-image ds-u-md-padding-y--1 ds-u-xl-padding-y--2 ds-u-justify-content--center'>
        <img alt='Medicare card example' src={`${process.env.PUBLIC_URL}/img/medicare-card-highlight-number.png`} />
      </div>
    </MyDrawer>
  )
}
